export default __webpack_public_path__ + "static/media/preauthcorrectimage.6064ece2.jfif";